import {Button, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {formatText} from 'presentation/utils';
import {ExamResultsTaggingEnum} from 'main/analytics/gaTagsEnum';
import {DataContentCard} from '../DataContentCard';
import {useExamCard} from './hooks/useExamCard';
import {
	StyledButtonsContainer,
	StyledCard,
	StyledDataContent,
	StyledHeaderContainer,
} from './styles';
import {ExamCardType} from './types';

const {showDetails} = translations['pt-br'].commons;
const {card} = translations['pt-br'].privateFlow.examResults;

export const ExamCard = ({exam, isWaitingResult}: ExamCardType) => {
	const {handleOpenExamDetails, descriptionDate, examType} = useExamCard({exam});

	return (
		<StyledCard>
			<StyledHeaderContainer>
				<Typography variant="h6" fontSize={18}>
					{examType?.label}
				</Typography>
			</StyledHeaderContainer>
			<StyledDataContent>
				<DataContentCard
					iconName="stethoscope"
					title={card.doctor}
					description={formatText(exam?.nmSolicitante)}
				/>
				<DataContentCard
					iconName="location-default"
					title={card.hospital}
					description={formatText(exam.dsPrestadorJuridico)}
				/>
				<DataContentCard
					iconName="query-builder-filled"
					title={card.examDate}
					description={descriptionDate}
				/>
			</StyledDataContent>

			<StyledButtonsContainer>
				<Button
					variant="contained"
					size="medium"
					fullWidth
					onClick={handleOpenExamDetails}
					data-tag-id={
						isWaitingResult
							? ExamResultsTaggingEnum.CLICK_DETALHES_EXAMES_AGUARDANDO_LIBERACAO
							: ExamResultsTaggingEnum.CLICK_DETALHES_EXAMES_LIBERADOS
					}>
					{showDetails}
				</Button>
			</StyledButtonsContainer>
		</StyledCard>
	);
};
